<template>
	<div class="omapi-integrations-filter">
		<div class="omapi-integrations-filter__filters">
			<div class="omapi-integrations-filter__filter-sort">
				<span>Sort:</span>
			</div>
			<div :class="filterClasses('email-marketing')" @click="setFilter('email-marketing')">
				<span>Email Marketing</span>
			</div>
			<div :class="filterClasses('crm')" @click="setFilter('crm')">
				<span>CRMs</span>
			</div>
			<div :class="filterClasses('remarketing')" @click="setFilter('remarketing')">
				<span>Remarketing</span>
			</div>
			<div
				class="omapi-integrations-filter__filter clear"
				:class="{ 'visually-hidden': !filters.length && !search.length }"
				@click="clearAll()"
			>
				<span>Clear</span>
			</div>
		</div>
		<div class="omapi-integrations-filter__search">
			<input
				placeholder="Search Integrations..."
				type="text"
				class="omapi-input"
				:value="search"
				@input="updateSearch"
				@keydown.esc="clearSearch"
			/>
			<svg-times v-if="search" class="clear-search" @click="clearSearch" />
		</div>
	</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('integrations');

export default {
	computed: {
		...mapState(['search', 'filters']),
	},
	methods: {
		/**
		 * Filter Classes
		 *
		 * @since 2.4.0
		 *
		 * @param {string} filter The filter slug.
		 *
		 * @returns {string} The clsses
		 */
		filterClasses(filter) {
			let classes = `omapi-integrations-filter__filter ${filter}`;

			if (-1 !== this.filters.indexOf(filter)) {
				classes += ' selected';
			}

			return classes;
		},
		/**
		 * Update Search
		 *
		 * @since 2.4.0
		 *
		 * @param {Object} e The event object.
		 *
		 * @returns {void}
		 */
		updateSearch(e) {
			this.$store.commit('integrations/setSearch', e.target.value);
		},
		/**
		 * Set Filter
		 *
		 * @since 2.4.0
		 *
		 * @param {string} filterBy The slug of the filter
		 *
		 * @returns {void}
		 */
		setFilter(filterBy) {
			this.clearFilter();
			this.$store.commit('integrations/setFilter', filterBy);
		},
		/**
		 * Clear Filter
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		clearFilter() {
			this.$store.commit('integrations/clearFilter');
		},
		/**
		 * Clear Search
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		clearSearch() {
			this.$store.commit('integrations/setSearch', '');
		},
		/**
		 * Clear All
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		clearAll() {
			this.clearFilter();
			this.clearSearch();
		},
	},
};
</script>
